// The entire purpose of this module is to import several libraries and expose them as globals. Namely: jQuery and Angular.JS.
//
// Angular.JS can only be imported once in all of our application code, as a result, we can't really get away with
// importing it in our main front-royal bundle. This is because our code gets split into multiple chunks, and we don't
// have any sort of guarantees around execution order, so we can't be sure that a given chunk that attempts to access
// the global `angular` object will be executing after the chunk that actually imports and exposes it.
//
// So we put Angular.JS in its own module/workspace/bundle with its own entrypoint in the Webpack config, and ensure we load
// the chunks from this bundle before any of our application code.
//
// We should be able to safely remove this module, and Yarn workspace, in isolation when we no longer have any Angular.JS code.
// Note that the core-js/stable and modernizr imports will likely need to be moved to the main front-royal bundle.

// oxlint-disable-next-line no-unused-vars
import { $, angular } from 'jqueryAndAngular';
import 'core-js/stable';
import './static/modernizr.custom.91603';
import 'Polyfills';

// On web, window.ENDPOINT_ROOT is set via _head_scripts.html.erb.
// On mobile, rspack.mobile.config.js replaces the __MOBILE_ENDPOINT_ROOT__ token with
// the actual value at build time, and we assign it to window.ENDPOINT_ROOT at runtime.
// This must happen before the app is bootstrapped.
if (window.CORDOVA) window.ENDPOINT_ROOT = __MOBILE_ENDPOINT_ROOT__;
